module.exports = __webpack_public_path__ + "static/media/stop-recording-icon.108a0b4c.svg";